import { USERTYPES } from "../../../constants/Constants";
import { encryptData } from "../../../helpers/RSAUtility";
import { getEnv } from '../../../helpers/EnvHelper';

export const firmDataModal = (values, state, role, formattedAutoAssignModality, hospitalCheckList, pacsNodeList, showPriorsStudiesList) => {
  const secondSignatureTextValue =
    values.signature2Dto?.signature2Text ?? values.signature2Dto?.signatureText ?? "";
  const thirdSignatureTextValue =
    values.signature3Dto?.signature3Text ?? values.signature3Dto?.signatureText ?? "";
  const encryptedName = encryptData(values.name);
  const encryptedAddress = encryptData(values.address);
  const encryptedCountry = encryptData(values.country);
  const encryptedState = encryptData(values.state);
  const encryptedCity = encryptData(values.city);
  const encryptedPriority_studies = values.priorityStudies;
  const contact1Name = encryptData(values.contact1.name);
  const contact1Email = encryptData(values.contact1.email);
  const contact1Type = encryptData(values.contact1.type);
  const contact1Mobile = encryptData(values.contact1.mobile);
  const contact1Landline = encryptData(values.contact1.landline);
  const signature2Text = encryptData(secondSignatureTextValue);
  const signature3Text = encryptData(thirdSignatureTextValue);
  // const accountWarning = encryptData(values.accountWarning);
  const customerSupportNumber=encryptData(values.customerSupportNumber);

  let contact1Flag = true;
  let contact2Flag = true;
  let contact3Flag = true;
  if (
    values.contact1.name == "" &&
    values.contact1.email == "" &&
    values.contact1.type == "" &&
    values.contact1.mobile == "" &&
    values.contact1.landline == ""
  ) {
    contact1Flag = false;
  }
  if (
    values.contact2.name == "" &&
    values.contact2.email == "" &&
    values.contact2.type == "" &&
    values.contact2.mobile == "" &&
    values.contact2.landline == ""
  ) {
    contact2Flag = false;
  }
  if (
    values.contact3.name == "" &&
    values.contact3.email == "" &&
    values.contact3.type == "" &&
    values.contact3.mobile == "" &&
    values.contact3.landline == ""
  ) {
    contact3Flag = false;
  }

  const contact2Name = encryptData(values.contact2.name);
  const contact2Email = encryptData(values.contact2.email);
  const contact2Type = encryptData(values.contact2.type);
  const contact2Mobile = encryptData(values.contact2.mobile);
  const contact2Landline = encryptData(values.contact2.landline);

  const contact3Name = encryptData(values.contact3.name);
  const contact3Email = encryptData(values.contact3.email);
  const contact3Type = encryptData(values.contact3.type);
  const contact3Mobile = encryptData(values.contact3.mobile);
  const contact3Landline = encryptData(values.contact3.landline);

  const bucketConfigSettings = {};
    values.modalityBuckets.forEach(item => {
      if (item.modality && item.bucketConfiguration != null) {
        bucketConfigSettings[item.modality] = item.bucketConfiguration;
      }
    });

    

  const firmDto = {
    name: encryptedName,
    address: encryptedAddress,
    country: encryptedCountry,
    state: encryptedState,
    city: encryptedCity,
    customerSupportNumber:customerSupportNumber,
    priorityStudies: encryptedPriority_studies,
    active: values.active,
    password_protected: values.password_protected,
    firmType: values.firmType,
    firmRole: role === USERTYPES.ADMIN ? null : values.firmRole,
    triageCTStudies: false,
    triageXRAYStudies: values.triageXRAYStudies,
    addTimeToReport: values.addTimeToReport ? 1 : 0,
    addDateToReport: values.addDateToReport ? 1 : 0,
    addSupervisorSignature: values.addSupervisorSignature,
    // accountWarning: accountWarning,
    accountWarning: values.accountWarning,
    isDOC: values.isDOC ? 1 : 0,
    isDOCX: values.isDOCX ? 1 : 0,
    isPDF: values.isPDF ? 1 : 0,
    isPDFWithImage: values.isPDFWithImage ? 1 : 0,
    isPDFWithKeyImage: values.isPDFWithKeyImage ? 1 : 0,
    isDOCXWithKeyImage: values.isDOCXWithKeyImage ? 1 : 0,
    qcEnabled: values.qcEnabled ? 1 : 0,
    preliminaryQcEnabled: values.preliminaryQcEnabled ? 1 : 0,
    masterStudyReportId: values.masterStudyReportId,
    watermarkImageUrl: values.watermarkImageUrl ?? null,
    watermarkOpacity: values.watermarkOpacity ?? 100,
    watermarkWidth: values.watermarkWidth ?? 100,
    watermarkRotation: values.watermarkRotation ?? 0,
    watermarkImage: values.watermarkImage ?? null,
    isWatermarkImageDeleted: values.isWatermarkImageDeleted ? 1 : 0,
    twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
    enableQCAutoAssignment: values.enableQCAutoAssignment ? 1: 0,
    modalityIds: values.modalityIds,
    autoAssignEnable: values.autoAssignEnable ? 1 : 0,
    autoAssignModalityIds: values.autoAssignModalityIds,
    addPrintDisclaimer: values.addPrintDisclaimer,
    printDisclaimerText: values.printDisclaimerText,
    addendumDisclaimerEnabled: values.addendumDisclaimerEnabled,
    addendumDisclaimerText: values.addendumDisclaimerText,
    historyAvailable: values.historyAvailable,
    reportHeaderDto: {
      headerImage: values.reportHeaderDto.headerImage,
      footerImage: values.reportHeaderDto.footerImage,
      headerImageUrl: values.reportHeaderDto.headerImageUrl,
      footerImageUrl: values.reportHeaderDto.footerImageUrl,
      isHeaderImageDeleted: values.reportHeaderDto.isHeaderImageDeleted ? 1 : 0,
      isFooterImageDeleted: values.reportHeaderDto.isFooterImageDeleted ? 1 : 0
    },
    signature2Dto: {
      signatureText: signature2Text,
      signatureImage: values.signature2Dto.signatureFile2,
      isSignatureImageDeleted: values.signature2Dto.isSignatureImageDeleted ? 1 : 0
    },
    signature3Dto: {
      signatureText: signature3Text,
      signatureImage: values.signature3Dto.signatureFile3,
      isSignatureImageDeleted: values.signature3Dto.isSignatureImageDeleted ? 1 : 0
    },
    historyAvailableDto: {
      historyAvailable: values.historyAvailable,
      modalityIds: values.historyModalityIds,
      clinicalNoteMandatory: values.clinicalNoteMandatory,
      technicianContactMandatory: values.technicianContactMandatory,
      subModalityMandatory: values.subModalityMandatory
    },
    studyLinkExpiryTime: values.studyLinkExpiryTime,
    qrLinkExpiryTime: values.qrLinkExpiryTime,
    enableShareReportLink: values.enableShareReportLink,
    reportLinkExpiryTime: values.reportLinkExpiryTime,
    reportLeftMarginPt:values.reportLeftMarginPt || null,
    reportRightMarginPt:values.reportRightMarginPt || null,
    updatedTimeString: values.updatedTimeString,
    schemeCode: values.schemeCode,
    exactMatchEnabled: values.exactMatchEnable ? values.exactMatchEnable: false,
    pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
    selectedPediatricModalityId: values.selectedPediatricModalityId,
    autoAssignModalityWithSubModalityIds: formattedAutoAssignModality(),
    isClientWarning: values.isClientWarning,
    allowDownloadStudy: values.allowDownloadStudy,
    allowDownloadReport: values.allowDownloadReport,
    enableQRCodeInReport: values.enableQRCodeInReport,
    enableWhatsApp: !!values.enableWhatsApp,
    whatsappNumber: values.whatsappNumber, 
    //enableEmail: values.enableEmail? true : true,
    enableEmail: typeof values.enableEmail === "undefined" ? true : !!values.enableEmail,
    notificationEmail: values.notificationEmail || null,
    firmEmailNotify: !!values.firmEmailNotify,
    firmWhatsappNotify: !!values.firmWhatsappNotify,
    firmTimeZone: values.firmTimeZone || getEnv("REACT_APP_BACKEND_TIMEZONE") || null,
    allowFirmAdminSetClientComm: !!values.allowFirmAdminSetClientComm,
    firmAdminCanEnableWhatsapp: !!values.firmAdminCanEnableWhatsapp,
    firmAdminCanEnableEmail: values.firmAdminCanEnableEmail == null ? true : !!values.firmAdminCanEnableEmail,
    enableStudySharingLinkInReport: values.enableStudySharingLinkInReport,
    emailPDF: values.emailPDF ? 1 : 0,
    emailDOCX: values.emailDOCX ? 1 : 0,
    emailDOC: values.emailDOC ? 1 : 0,
    enableUnassignmentService: values.enableUnassignmentService,
    unassignmentModalityIds: values.unassignmentModalityIds || [],
    reqBlankLines: values.reqBlankLines,
    reqBlankLinesAfterHeader:values.reqBlankLinesAfterHeader,
    priorityCount: values.priorityCount,
    firmIdList: hospitalCheckList,
    headerTextLine1: values.headerTextLine1,
    headerTextLine2: values.headerTextLine2,
    branchCode: values.branchCode,
    showWord: values.showWord,
    selectedSubModalityListNumber: values.selectedSubModalityListNumber,
    pacsNodeList: pacsNodeList,
    showPriorsConnectionDtoList: showPriorsStudiesList,
    cxrVersionViewer: values.cxrVersionViewer,
    cxrVersionStudyList: values.cxrVersionStudyList,  
    boneEnabled: values.boneEnabled,
    showFindings : values.showFindings,
    showProbability : values.showProbability,
    cxrTriageMinAge: values.cxrTriageMinAge ?? null,
    subtleFindings: values.subtleFindings,
    showPriorsStudies: values.showPriorsStudies,
    showAboveThresholdScore: values.showAboveThresholdScore,
    enableGenkiStudyInference : values.enableGenkiStudyInference,
    enableSecondaryCapture: values.enableSecondaryCapture,
    multiframeSplit: typeof values.multiframeSplit === "undefined" ? true : !!values.multiframeSplit,
    enableQualityModel: values.enableQualityModel ?? false, //Added qualityModel flag
    compressStudyDownload: values.compressStudyDownload ?? false,
    demoFirm: values.demoFirm ?? false,
    demoExpiryDate: values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate)
      ? `${values.demoExpiryDate.getFullYear()}-${String(values.demoExpiryDate.getMonth() + 1).padStart(2, '0')}-${String(values.demoExpiryDate.getDate()).padStart(2, '0')}`
      : (values.demoExpiryDate ?? null),
    maxStudyUploads: values.maxStudyUploads ?? null,
    externalFirm: values.externalFirm ? 1 : 0,
    bucketConfigSettings: bucketConfigSettings,
    sendReportSubmitNotification: values.sendReportSubmitNotification ? 1 : 0,
    enableCriticalAlert: values.enableCriticalAlert ? true : false,
    addendumWorkflowEnabled: values.addendumWorkflowEnabled ? 1 : 0,
    showAiResultsSavedReportForFirmDoctors: values.showAiResultsSavedReportForFirmDoctors ? 1 : 0,
  };
  if (contact1Flag) {
    firmDto["contact1"] = {
      name: contact1Name,
      email: contact1Email,
      type: contact1Type,
      mobile: contact1Mobile,
      landline: contact1Landline,
    };
  }
  if (contact2Flag) {
    firmDto["contact2"] = {
      name: contact2Name,
      email: contact2Email,
      type: contact2Type,
      mobile: contact2Mobile,
      landline: contact2Landline,
    };
  }
  if (contact3Flag) {
    firmDto["contact3"] = {
      name: contact3Name,
      email: contact3Email,
      type: contact3Type,
      mobile: contact3Mobile,
      landline: contact3Landline,
    };
  }
  console.log("firmDto " + JSON.stringify(firmDto, null, 2));
  if (state.action == "EDIT") {
    firmDto["id"] = state.firmDto.id;
  }

  return firmDto;
};

export const adminFirmEditDataModal = (values, clientId, firmId, formattedAutoAssignModality, selectedRadiologistMap, selectedSupervisorMap, selectedPacsList) => {
  const secondSignatureTextValue =
    values.signature2Dto?.signature2Text ?? values.signature2Dto?.signatureText ?? "";
  const thirdSignatureTextValue =
    values.signature3Dto?.signature3Text ?? values.signature3Dto?.signatureText ?? "";

  var radiologistMap = [];
  for (let [key, value] of selectedRadiologistMap) {
    radiologistMap.push({
      userId: key,
      modalityIds: value,
    });
  }

  var supervisorMap = [];
  for (let [key, value] of selectedSupervisorMap) {
    supervisorMap.push({
      userId: key,
      modalityIds: value,
    });
  }

  const bucketConfigSettings = {};
  values.modalityBuckets.forEach(item => {
    if (item.modality && item.bucketConfiguration != null) {
      bucketConfigSettings[item.modality] = item.bucketConfiguration;
    }
  });

  const dto  = {
    clientAccessDto: {
      firmId: firmId,
      clientId: clientId,
      radiologistIdList: radiologistMap,
      supervisorIdList: supervisorMap
    },
    qcSettingDto: {
      firmId: firmId,
      clientId: clientId,
      qcEnabled: values.qcEnabled ? 1 : 0,
      preliminaryQcEnabled: values.preliminaryQcEnabled ? 1 : 0,
      twoSignaturesAllowed: values.twoSignaturesAllowed ? 1 : 0,
      enableQCAutoAssignment: values.enableQCAutoAssignment ? 1 : 0,
      modalityIds: values.modalityIds.filter(h => h != null).sort((a,b) => a-b)
    },
    historyAvailableDto: {
      firmId: firmId,
      clientId: clientId,
      historyAvailable: values.historyAvailable,
      modalityIds: values.historyModalityIds.filter(h => h!= null).sort((a,b) => a-b),
      clinicalNoteMandatory: values.clinicalNoteMandatory,
      technicianContactMandatory: values.technicianContactMandatory,
      subModalityMandatory: values.subModalityMandatory
    },
    autoAssignEnableDto: {
      firmId: firmId,
      clientId: clientId,
      autoAssignEnabled: values.autoAssignEnable ? 1 : 0,
      modalityIds: values.autoAssignModalityIds.filter(a => a != null).sort((a,b) => a-b),
      modalityWithSubModalityIds: formattedAutoAssignModality(),
      exactMatchEnabled: values.exactMatchEnable ? values.exactMatchEnable: false,
      pediatricAssignmentEnabled: values.pediatricAssignmentEnabled ? 1 : 0,
      selectedPediatricModalityId: values.selectedPediatricModalityId
    },
    disclaimerDto: {
      firmId: firmId,
      clientId: clientId,
      addPrintDisclaimer: values.addPrintDisclaimer,
      printDisclaimerText: values.printDisclaimerText === undefined ? "" : values.printDisclaimerText,
      accountWarning: values.accountWarning,
      priorityStudyCount: values.priorityCount,
      showPriorsStudies: values.showPriorsStudies,
      sendReportSubmitNotification: values.sendReportSubmitNotification ? 1 : 0,
      demoFirm: values.demoFirm ?? false,
      demoExpiryDate: values.demoExpiryDate instanceof Date && !isNaN(values.demoExpiryDate)
        ? `${values.demoExpiryDate.getFullYear()}-${String(values.demoExpiryDate.getMonth() + 1).padStart(2, '0')}-${String(values.demoExpiryDate.getDate()).padStart(2, '0')}`
        : (values.demoExpiryDate ?? null),
      maxStudyUploads: values.maxStudyUploads ?? null,
    },
    configureSettingDto: {
      firmId: firmId,
      clientId: clientId,
      branchCode: values.branchCode,
      showWord: values.showWord,
      selectedSubModalityListNumber: values.selectedSubModalityListNumber,
      bucketConfigSettings: bucketConfigSettings,
      firmTimeZone: values.firmTimeZone || getEnv("REACT_APP_BACKEND_TIMEZONE") || null,
      addendumWorkflowEnabled: values.addendumWorkflowEnabled ? 1 : 0,
      showAiResultsSavedReportForFirmDoctors: values.showAiResultsSavedReportForFirmDoctors ? 1 : 0,
    },
    configurePacsNodeDto: {
      firmId: firmId,
      clientId: clientId,
      selectedPacsNodes: selectedPacsList
    },
    unassignmentServiceDto: {
      firmId: firmId,
      clientId: clientId,
      firmEnableUnassignmentService: values.firmEnableUnassignmentService,
      unassignmentModalityIds: (values.unassignmentModalityIds && Array.isArray(values.unassignmentModalityIds)) 
    ? values.unassignmentModalityIds.filter(m => m != null) 
    : []
    },
    firmSettingsDto:{
      name: values.name,
      address: values.address,
      city: values.city,
      state: values.state,
      country: values.country,
      enableSecondaryCapture: values.enableSecondaryCapture,
      enableGenkiStudyInference: values.enableGenkiStudyInference,
      multiframeSplit: typeof values.multiframeSplit === "undefined" ? true : !!values.multiframeSplit,
      enableQualityModel: values.enableQualityModel ?? false,  // ADD THIS Quality Model Flag
      compressStudyDownload: values.compressStudyDownload ?? false,
      enableWhatsApp: !!values.enableWhatsApp,
      whatsappNumber: values.whatsappNumber,
      enableEmail: typeof values.enableEmail === "undefined" ? true : !!values.enableEmail,
      notificationEmail: values.notificationEmail || null,
      triageXRAYStudies: values.triageXRAYStudies,
    },
    reportTemplateDto: {
      firmId: firmId,
      clientId: clientId,
      headerImageUrl: values.reportHeaderDto?.headerImageUrl,
      footerImageUrl: values.reportHeaderDto?.footerImageUrl,
      isHeaderImageDeleted: values.reportHeaderDto?.isHeaderImageDeleted ? 1 : 0,
      isFooterImageDeleted: values.reportHeaderDto?.isFooterImageDeleted ? 1 : 0,
      reqBlankLines: values.reqBlankLines,
      reqBlankLinesAfterHeader: values.reqBlankLinesAfterHeader,
      headerTextLine1: values.headerTextLine1,
      headerTextLine2: values.headerTextLine2,
      isDOC: values.isDOC ? 1 : 0,
      isDOCX: values.isDOCX ? 1 : 0,
      isPDF: values.isPDF ? 1 : 0,
      isPDFWithImage: values.isPDFWithImage ? 1 : 0,
      isPDFWithKeyImage: values.isPDFWithKeyImage ? 1 : 0,
      isDOCXWithKeyImage: values.isDOCXWithKeyImage ? 1 : 0,
      masterStudyReportId: values.masterStudyReportId,
      watermarkImageUrl: values.watermarkImageUrl ?? null,
      isWatermarkImageDeleted: values.isWatermarkImageDeleted ? 1 : 0,
      watermarkOpacity: values.watermarkOpacity ?? 100,
      watermarkWidth: values.watermarkWidth ?? 100,
      watermarkRotation: values.watermarkRotation ?? 0,
      reportLeftMarginPt:values.reportLeftMarginPt || null,
      reportRightMarginPt:values.reportRightMarginPt || null,

    },
    reportSettingDto: {
      firmId: firmId,
      clientId: clientId,
      addTimeToReport: values.addTimeToReport ? 1 : 0,
      addDateToReport: values.addDateToReport ? 1 : 0,
      addSupervisorSignature: values.addSupervisorSignature,
      studyLinkExpiryTime: values.studyLinkExpiryTime,
      qrLinkExpiryTime: values.qrLinkExpiryTime,
      enableShareReportLink: values.enableShareReportLink,
      enableStudySharingLinkInReport: values.enableStudySharingLinkInReport,
      reportLinkExpiryTime: values.reportLinkExpiryTime,
      sendReportSubmitNotification: values.sendReportSubmitNotification ? 1 : 0,
      addendumDisclaimerEnabled: values.addendumDisclaimerEnabled,
      addendumDisclaimerText: values.addendumDisclaimerText === undefined ? "" : values.addendumDisclaimerText,
      enableQRCodeInReport: values.enableQRCodeInReport,
      emailPDF: values.emailPDF ? 1 : 0,
      emailDOCX: values.emailDOCX ? 1 : 0,
      emailDOC: values.emailDOC ? 1 : 0,
      signature2Dto: {
        signatureText: secondSignatureTextValue,
        isSignatureImageDeleted: values.signature2Dto?.isSignatureImageDeleted ? 1 : 0
      },
      signature3Dto: {
        signatureText: thirdSignatureTextValue,
        isSignatureImageDeleted: values.signature3Dto?.isSignatureImageDeleted ? 1 : 0
      },
    }
  }

  return dto;

}

/** Sample preview payload from live form values. */
export const buildSampleReportPreviewDto = (values, clientId, firmId) => {
  const secondSignatureTextValue =
    values.signature2Dto?.signature2Text ?? values.signature2Dto?.signatureText ?? "";
  const thirdSignatureTextValue =
    values.signature3Dto?.signature3Text ?? values.signature3Dto?.signatureText ?? "";

  const resolvedClientId = clientId || values?.id || null;
  const resolvedFirmId = firmId || null;

  return {
    clientId: resolvedClientId || null,
    reportTemplateDto: {
      firmId: resolvedFirmId,
      clientId: resolvedClientId,
      headerImageUrl: values.reportHeaderDto?.headerImageUrl,
      footerImageUrl: values.reportHeaderDto?.footerImageUrl,
      isHeaderImageDeleted: values.reportHeaderDto?.isHeaderImageDeleted ? 1 : 0,
      isFooterImageDeleted: values.reportHeaderDto?.isFooterImageDeleted ? 1 : 0,
      reqBlankLines: values.reqBlankLines,
      reqBlankLinesAfterHeader: values.reqBlankLinesAfterHeader,
      headerTextLine1: values.headerTextLine1,
      headerTextLine2: values.headerTextLine2,
      isDOC: values.isDOC ? 1 : 0,
      isDOCX: values.isDOCX ? 1 : 0,
      isPDF: values.isPDF ? 1 : 0,
      isPDFWithImage: values.isPDFWithImage ? 1 : 0,
      isPDFWithKeyImage: values.isPDFWithKeyImage ? 1 : 0,
      isDOCXWithKeyImage: values.isDOCXWithKeyImage ? 1 : 0,
      masterStudyReportId: values.masterStudyReportId,
      watermarkImageUrl: values.watermarkImageUrl ?? null,
      isWatermarkImageDeleted: values.isWatermarkImageDeleted ? 1 : 0,
      watermarkOpacity: values.watermarkOpacity ?? 100,
      watermarkWidth: values.watermarkWidth ?? 100,
      watermarkRotation: values.watermarkRotation ?? 0,
      reportLeftMarginPt: values.reportLeftMarginPt || null,
      reportRightMarginPt: values.reportRightMarginPt || null,
    },
    reportSettingDto: {
      firmId: resolvedFirmId,
      clientId: resolvedClientId,
      addTimeToReport: !!values.addTimeToReport,
      addDateToReport: !!values.addDateToReport,
      addSupervisorSignature: !!values.addSupervisorSignature,
      studyLinkExpiryTime: values.studyLinkExpiryTime,
      qrLinkExpiryTime: values.qrLinkExpiryTime,
      enableShareReportLink: !!values.enableShareReportLink,
      enableStudySharingLinkInReport: !!values.enableStudySharingLinkInReport,
      reportLinkExpiryTime: values.reportLinkExpiryTime,
      sendReportSubmitNotification: values.sendReportSubmitNotification ? 1 : 0,
      addendumDisclaimerEnabled: !!values.addendumDisclaimerEnabled,
      addendumDisclaimerText:
        values.addendumDisclaimerText === undefined ? "" : values.addendumDisclaimerText,
      enableQRCodeInReport: !!values.enableQRCodeInReport,
      emailPDF: !!values.emailPDF,
      emailDOCX: !!values.emailDOCX,
      emailDOC: !!values.emailDOC,
      signature2Dto: {
        signatureText: secondSignatureTextValue,
        isSignatureImageDeleted: values.signature2Dto?.isSignatureImageDeleted ? 1 : 0,
      },
      signature3Dto: {
        signatureText: thirdSignatureTextValue,
        isSignatureImageDeleted: values.signature3Dto?.isSignatureImageDeleted ? 1 : 0,
      },
    },
    disclaimerDto: {
      firmId: resolvedFirmId,
      clientId: resolvedClientId,
      addPrintDisclaimer: !!values.addPrintDisclaimer,
      printDisclaimerText:
        values.printDisclaimerText === undefined ? "" : values.printDisclaimerText,
    },
  };
};
